import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FolderSection, LabelValue } from '../Elements';
import Translate, { t } from '../../common/Translate';
import { useCounterAppraisal } from '../../../hooks/useCalendar/useRecordBlocs/useCounterAppraisal';

export const CounterAppraisalBloc = ({ recordId }) => {
  const {
    originId,
    counterInspection,
    isVisible,
    initialize,
    isOpen,
    toggle,
    totals,
    downloadPdf,
    newPdfUrl,
    showNewPdf,
  } = useCounterAppraisal({ recordId });

  return (
    <>
      <FolderSection
        title={t('counter-appraisal')}
        dataTestid="counter-appraisal-bloc"
        action={(event) => {
          if (!counterInspection?.recordId && isVisible) {
            toggle();
          } else {
            initialize(event);
          }
        }}
        showArrow={isVisible}
      >
        {isVisible && (
          <>
            {totals.map(({ label, value }) => (
              <LabelValue label={label} key={label} value={value} />
            ))}
            <Row className="mt-2">
              <Col xs="8" sm="3" lg="5">
                {(newPdfUrl || downloadPdf) && (
                  <Row>
                    <a
                      target="_blank"
                      data-testid="counter-appraisal-pdf-link"
                      href={showNewPdf ? newPdfUrl : downloadPdf}
                      className="download-btn"
                      rel="noopener noreferrer"
                      id="theHref"
                    >
                      <Translate code="download" />
                    </a>
                  </Row>
                )}
              </Col>
            </Row>
          </>
        )}
      </FolderSection>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalBody className="pb-0 text-center">
          <FontAwesomeIcon icon={faBell} color="red" className="mr-3 fa-lg" />
          <span className="text-danger" style={{ lineHeight: 1.4 }}>
            {originId < 10 ? t('warningPopUpCounterAppraisalB2b') : t('warningPopUpCounterAppraisal')}
          </span>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <button type="button" className="btn btn-3 mr-2" onClick={toggle}>
            {t('cancel')}
          </button>
          <button
            type="button"
            className="btn btn-1"
            onClick={(event) => {
              toggle();
              initialize(event);
            }}
          >
            {t('confirm')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

CounterAppraisalBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
